// extracted by mini-css-extract-plugin
export default {"root":"OjNyjgKmBY","settings":"LV30LFSLX4","results":"n8aadt9BPr"};